export interface VesselSection {
  current: number;
  max: number;
  hasDealtHoleDamage?: boolean;
}

export interface VesselData {
  name: string;
  hullSections: number;
  sinkSections: number;
  decks: number;
  sectionsPerDeck: number;
  sectionHP: number;
  riggingSections: number;
  riggingHP: number;
}

export const VESSEL_DATA: Record<string, VesselData> = {
  'Barge': {
    name: 'Barge',
    hullSections: 80,
    sinkSections: 20,
    decks: 1,
    sectionsPerDeck: 80,
    sectionHP: 50,
    riggingSections: 0,
    riggingHP: 0
  },
  'Caravel': {
    name: 'Caravel',
    hullSections: 24,
    sinkSections: 6,
    decks: 2,
    sectionsPerDeck: 12,
    sectionHP: 80,
    riggingSections: 3,
    riggingHP: 80
  },
  'Cog': {
    name: 'Cog',
    hullSections: 16,
    sinkSections: 4,
    decks: 2,
    sectionsPerDeck: 8,
    sectionHP: 80,
    riggingSections: 1,
    riggingHP: 60
  },
  'Coracle': {
    name: 'Coracle',
    hullSections: 1,
    sinkSections: 1,
    decks: 1,
    sectionsPerDeck: 1,
    sectionHP: 10,
    riggingSections: 0,
    riggingHP: 0
  },
  'Dhow': {
    name: 'Dhow',
    hullSections: 18,
    sinkSections: 4,
    decks: 3,
    sectionsPerDeck: 6,
    sectionHP: 50,
    riggingSections: 1,
    riggingHP: 60
  },
  'Dromond': {
    name: 'Dromond',
    hullSections: 60,
    sinkSections: 15,
    decks: 5,
    sectionsPerDeck: 12,
    sectionHP: 80,
    riggingSections: 2,
    riggingHP: 80
  },
  'Dugout': {
    name: 'Dugout',
    hullSections: 1,
    sinkSections: 1,
    decks: 1,
    sectionsPerDeck: 1,
    sectionHP: 10,
    riggingSections: 0,
    riggingHP: 0
  },
  'Elf Wingship': {
    name: 'Elf Wingship',
    hullSections: 12,
    sinkSections: 3,
    decks: 1,
    sectionsPerDeck: 12,
    sectionHP: 150,
    riggingSections: 2,
    riggingHP: 80
  },
  'Galley': {
    name: 'Galley',
    hullSections: 78,
    sinkSections: 19,
    decks: 3,
    sectionsPerDeck: 26,
    sectionHP: 80,
    riggingSections: 2,
    riggingHP: 60
  },
  'Greatship': {
    name: 'Greatship',
    hullSections: 240,
    sinkSections: 60,
    decks: 6,
    sectionsPerDeck: 40,
    sectionHP: 80,
    riggingSections: 4,
    riggingHP: 80
  },
  'Ironclad': {
    name: 'Ironclad',
    hullSections: 72,
    sinkSections: 18,
    decks: 3,
    sectionsPerDeck: 24,
    sectionHP: 150,
    riggingSections: 1,
    riggingHP: 60
  },
  'Junk': {
    name: 'Junk',
    hullSections: 32,
    sinkSections: 8,
    decks: 2,
    sectionsPerDeck: 16,
    sectionHP: 50,
    riggingSections: 2,
    riggingHP: 80
  },
  'Keelboat': {
    name: 'Keelboat',
    hullSections: 3,
    sinkSections: 1,
    decks: 1,
    sectionsPerDeck: 3,
    sectionHP: 50,
    riggingSections: 1,
    riggingHP: 60
  },
  'Launch': {
    name: 'Launch',
    hullSections: 1,
    sinkSections: 1,
    decks: 1,
    sectionsPerDeck: 1,
    sectionHP: 50,
    riggingSections: 0,
    riggingHP: 0
  },
  'Longship': {
    name: 'Longship',
    hullSections: 14,
    sinkSections: 3,
    decks: 1,
    sectionsPerDeck: 14,
    sectionHP: 50,
    riggingSections: 1,
    riggingHP: 60
  },
  'Pinnace': {
    name: 'Pinnace',
    hullSections: 4,
    sinkSections: 1,
    decks: 1,
    sectionsPerDeck: 4,
    sectionHP: 50,
    riggingSections: 2,
    riggingHP: 60
  },
  'Raft': {
    name: 'Raft',
    hullSections: 1,
    sinkSections: 1,
    decks: 1,
    sectionsPerDeck: 1,
    sectionHP: 30,
    riggingSections: 0,
    riggingHP: 0
  },
  'Rowboat': {
    name: 'Rowboat',
    hullSections: 1,
    sinkSections: 1,
    decks: 1,
    sectionsPerDeck: 1,
    sectionHP: 30,
    riggingSections: 0,
    riggingHP: 0
  },
  'Theurgeme': {
    name: 'Theurgeme',
    hullSections: 28,
    sinkSections: 7,
    decks: 2,
    sectionsPerDeck: 14,
    sectionHP: 150,
    riggingSections: 0,
    riggingHP: 0
  },
  'Trireme': {
    name: 'Trireme',
    hullSections: 32,
    sinkSections: 8,
    decks: 2,
    sectionsPerDeck: 16,
    sectionHP: 50,
    riggingSections: 1,
    riggingHP: 60
  },
  'War Canoe': {
    name: 'War Canoe',
    hullSections: 2,
    sinkSections: 1,
    decks: 1,
    sectionsPerDeck: 2,
    sectionHP: 30,
    riggingSections: 1,
    riggingHP: 40
  }
}; 